import React, {Component} from 'react';
import {connect} from "react-redux";
import {setCoords} from "../redux/coords/action";


const withMyCoordsHOC = (OriginalComponent) => {
    class WithMyCoordsHOC extends Component{
        componentWillMount() {
            if(!this.props.myCoords.lat || !this.props.myCoords.lng){
                console.log('set coords')
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        async position => {
                            this.props.setCoords(
                                position.coords.latitude,
                                position.coords.longitude
                            )
                        }, error => {
                            console.log('pos error')

                        }
                    )
                } else {
                    console.log('no navigator')

                }
            }
        }

        render() {
            return <OriginalComponent {...this.props}/>
        }
    }
    const mapStateToProps = state => {
        return{
            myCoords: state.myCoords
        }
    }
    const mapDispatchToProps = dispatch => {
        return{
            setCoords: (lat,lng) => dispatch(setCoords(lat, lng))
        }
    }

    return connect(mapStateToProps, mapDispatchToProps)(WithMyCoordsHOC)
}


export default withMyCoordsHOC